import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202508: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202508",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-08-01",
  endDate: "2025-08-31",
  impressions: 85880,
  clicks: 1954,
  adsSpendDollars: 4011,
  budgetDollars: 4100,
  salesDollars: 12952,
  bestEstimateRoas: 3.23,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 30,
  dataAvailableAtDate: "2025-09-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
